export default __webpack_public_path__ + "static/media/Ndifeke Mattew.8c388c81.jpg";